module.exports = __webpack_public_path__ + "static/gallery-11@2x-a69558385e0aadcf569d48c5641f2b73.jpg";